// Shared Expand / Pin / Close header for operator Messages and Smoke Drive.

import React from 'react';
import {
    CloseOutlined,
    ExpandOutlined,
    CompressOutlined,
    PushpinFilled,
    PushpinOutlined,
} from '@ant-design/icons';

/**
 * @param {{
 *   title: string,
 *   pinned: boolean,
 *   expanded: boolean,
 *   onToggleExpand: () => void,
 *   onTogglePin: () => void,
 *   onClose: () => void,
 *   onHandlePointerDown?: (e: object) => void,
 *   closeAriaLabel: string,
 *   expandTitle: string,
 *   extraActions?: React.ReactNode,
 * }} props
 */
export default function OperatorWorkspaceChromeHeader({
    title,
    pinned,
    expanded,
    onToggleExpand,
    onTogglePin,
    onClose,
    onHandlePointerDown,
    closeAriaLabel,
    expandTitle,
    extraActions,
    isMobile = false,
}) {
    return (
        <div
            className={`op-msg-modal__header${pinned ? ' is-drag-handle' : ''}${
                isMobile ? ' is-mobile' : ''
            }`}
            onPointerDown={pinned ? onHandlePointerDown : undefined}
            title={pinned ? 'Drag to move' : undefined}
        >
            <div>
                <p className="op-msg-modal__eyebrow">London Smoke &amp; Cure</p>
                <h2 className="op-msg-modal__title">{title}</h2>
                {pinned && !isMobile ? (
                    <p className="op-msg-modal__pin-hint">
                        Pinned — page stays usable; drag header to move
                        {expanded ? ' (expanded)' : ' (compact)'}
                    </p>
                ) : null}
            </div>
            <div className="op-msg-modal__header-actions">
                {extraActions}
                {!isMobile ? (
                    <button
                        type="button"
                        className={`op-msg-modal__chrome-btn${expanded ? ' is-on' : ''}`}
                        onClick={onToggleExpand}
                        aria-pressed={expanded}
                        aria-label={expanded ? 'Collapse workspace' : 'Expand workspace'}
                        title={expanded ? 'Collapse' : expandTitle}
                    >
                        {expanded ? <CompressOutlined /> : <ExpandOutlined />}
                        <span>{expanded ? 'Collapse' : 'Expand'}</span>
                    </button>
                ) : null}
                <button
                    type="button"
                    className={`op-msg-modal__chrome-btn${pinned ? ' is-on is-pin' : ''}`}
                    onClick={onTogglePin}
                    aria-pressed={pinned}
                    aria-label={pinned ? 'Unpin workspace' : 'Pin workspace at current size'}
                    title={
                        pinned
                            ? 'Unpin — restore modal backdrop'
                            : 'Pin — keep open over the page; drag header to move'
                    }
                >
                    {pinned ? <PushpinFilled /> : <PushpinOutlined />}
                    <span>{pinned ? 'Unpin' : 'Pin'}</span>
                </button>
                <button
                    type="button"
                    className="op-msg-modal__close"
                    onClick={onClose}
                    aria-label={closeAriaLabel}
                >
                    <CloseOutlined />
                </button>
            </div>
        </div>
    );
}
